module.exports = __webpack_public_path__ + "static/media/background-pagamentos2-mobile.ab7eb427.jpg";